var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _path18, _path19, _g3, _path20, _path21, _path22, _path23, _g4, _path24, _path25, _path26, _path27, _g5, _path28, _path29, _path30, _path31, _g6, _path32, _path33, _path34, _path35, _g7, _path36, _path37, _path38, _path39, _g8, _g9, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g0, _path47, _g1, _g10, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarAfinandinhoSucesso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 171,
    viewBox: "0 0 183 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.747 122.25C159.582 106.385 157.254 88.356 141.939 78.5106C127.101 68.9714 110.452 88.0166 92.2561 91.3043C75.0542 94.4123 48.8364 89.1191 39.6581 101.51C29.815 114.797 30.2493 130.884 38.2323 145.179C46.0895 159.248 64.1422 165.792 84.0102 168.252C103.333 170.644 117.16 165.436 132.765 157.824C146.678 149.144 156.079 136.676 157.747 122.25Z",
    fill: "#8974FF",
    fillOpacity: 0.09
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 150.083C143.838 150.083 157.083 136.839 157.083 120.5C157.083 104.162 143.838 90.9167 127.5 90.9167C111.162 90.9167 97.9167 104.162 97.9167 120.5C97.9167 136.839 111.162 150.083 127.5 150.083Z",
    fill: "#77B255"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.542 130.854C124.152 130.856 123.766 130.782 123.406 130.635C123.046 130.487 122.718 130.27 122.441 129.996L113.566 121.121C113.29 120.845 113.072 120.518 112.922 120.158C112.773 119.797 112.696 119.411 112.696 119.021C112.696 118.233 113.009 117.478 113.566 116.92C114.123 116.363 114.879 116.05 115.667 116.05C116.454 116.05 117.21 116.363 117.767 116.92L124.542 123.725L137.233 111.004C137.79 110.447 138.546 110.134 139.333 110.134C140.121 110.134 140.877 110.447 141.434 111.004C141.991 111.561 142.304 112.316 142.304 113.104C142.304 113.892 141.991 114.648 141.434 115.205L126.642 129.996C126.366 130.27 126.038 130.487 125.677 130.635C125.317 130.782 124.931 130.856 124.542 130.854Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2005_12792)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5925 125.77L78.3332 122.7C78.3332 122.7 75.2292 121.124 70.7984 121.592C70.8318 121.507 52.8894 122.529 51.2644 125.633C51.2157 125.716 52.5516 129.069 52.5516 129.069L62.8831 128.171L76.5925 125.77Z",
    fill: "#ADADAD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.33 122.7C85.6488 126.747 90.6365 134.665 90.7795 144.026C90.9956 158.107 80.162 170.112 66.5834 170.839C53.0079 171.567 41.8274 160.739 41.6113 146.658C41.4835 138.259 45.2874 130.6 51.2581 125.63C51.8819 125.703 52.5058 125.758 53.1236 125.795C61.6261 126.272 70.5213 124.946 78.33 122.7Z",
    fill: "url(#paint0_linear_2005_12792)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.6143 146.662C41.4865 138.263 45.2905 130.603 51.2611 125.634C51.4376 125.655 51.6141 125.67 51.7906 125.688C47.0585 130.6 44.1584 137.386 44.268 144.738C44.484 158.819 55.6615 169.647 69.2401 168.919C73.5431 168.688 77.5692 167.325 81.0566 165.122C77.0306 168.445 72.0306 170.55 66.5864 170.843C53.0079 171.567 41.8274 160.742 41.6143 146.662Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0589 127.797C70.0589 127.797 70.3115 128.165 70.6888 128.85C70.8745 129.194 71.0997 129.614 71.3279 130.107C71.5592 130.6 71.8148 131.16 72.0552 131.787C72.183 132.097 72.3047 132.426 72.4265 132.767C72.5543 133.107 72.6699 133.463 72.7825 133.832C73.0199 134.565 73.2451 135.347 73.4338 136.169C73.522 136.58 73.6255 136.997 73.7076 137.423C73.7868 137.849 73.8659 138.281 73.9389 138.719C73.9967 139.157 74.0546 139.602 74.1124 140.046C74.1672 140.49 74.1885 140.941 74.228 141.391C74.2676 141.841 74.2737 142.292 74.2858 142.739C74.298 143.183 74.3071 143.646 74.2919 144.078C74.2889 144.945 74.2311 145.813 74.1885 146.656C74.155 147.072 74.1306 147.486 74.0911 147.888C74.0515 148.29 73.9998 148.682 73.9572 149.063C73.9115 149.443 73.8568 149.814 73.802 150.173C73.7442 150.533 73.6742 150.876 73.6163 151.205C73.5524 151.534 73.4824 151.85 73.4185 152.148C73.3425 152.447 73.2694 152.727 73.1994 152.991C73.0534 153.518 72.9042 153.971 72.7612 154.336C72.4873 155.073 72.2439 155.453 72.2439 155.453C72.2439 155.453 72.3869 155.03 72.5208 154.27C72.5938 153.892 72.6547 153.427 72.7278 152.897C72.7917 152.365 72.8464 151.762 72.9012 151.108C72.9499 150.45 72.9864 149.738 73.0199 148.984C73.0503 148.229 73.0564 147.435 73.0807 146.61C73.0807 146.199 73.0838 145.782 73.0838 145.362C73.0808 144.936 73.0747 144.504 73.0716 144.069C73.0747 143.628 73.0503 143.214 73.0381 142.776C73.026 142.343 73.0138 141.908 72.9742 141.473C72.9377 141.041 72.9225 140.603 72.8738 140.174C72.8282 139.742 72.7795 139.312 72.7338 138.886C72.6699 138.463 72.6121 138.04 72.5573 137.623C72.4995 137.207 72.4173 136.799 72.3504 136.394C72.1952 135.591 72.0522 134.809 71.8787 134.078C71.7996 133.71 71.7083 133.354 71.6231 133.01C71.5409 132.663 71.4587 132.331 71.3705 132.015C71.2001 131.379 71.0327 130.795 70.8775 130.28C70.7193 129.766 70.5793 129.319 70.4576 128.95C70.3328 128.582 70.2324 128.296 70.1654 128.098C70.0985 127.901 70.0589 127.797 70.0589 127.797Z",
    fill: "#662D91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4482 134.903C77.3015 136.519 77.977 139.614 76.9515 141.817C75.929 144.02 73.5979 144.498 71.7447 142.882C69.8914 141.266 69.2188 138.171 70.2413 135.968C71.2638 133.765 73.5949 133.29 75.4482 134.903Z",
    fill: "#CCA244"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7476 142.876C69.8944 141.26 69.2188 138.165 70.2443 135.962C70.4604 135.496 70.7343 135.11 71.0508 134.802C71.8116 134.818 72.6058 135.128 73.327 135.758C75.1803 137.374 75.8559 140.469 74.8304 142.672C74.6143 143.138 74.3404 143.524 74.0239 143.832C73.2631 143.816 72.4689 143.506 71.7476 142.876Z",
    fill: "#FFCA55"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M72.4142 139.221C71.769 138.908 70.9961 138.275 71.0113 137.38C71.0234 136.601 71.7538 136.215 72.3807 136.421C73.8444 136.902 74.3314 140.155 72.4142 139.221Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4191 143.588C73.601 145.49 76.3429 144.927 77.548 142.334C78.75 139.741 77.9588 136.099 75.7769 134.197C73.5949 132.295 70.853 132.858 69.648 135.451C68.4459 138.046 69.2371 141.689 71.4191 143.588ZM70.2414 135.968C71.2639 133.765 73.5949 133.287 75.4482 134.903C77.3015 136.519 77.9771 139.614 76.9515 141.817C75.929 144.02 73.598 144.498 71.7447 142.882C69.8914 141.269 69.2189 138.171 70.2414 135.968Z",
    fill: "#662D91"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6747 142.967C69.791 141.324 69.1033 138.165 70.141 135.922C70.6461 134.833 71.48 134.115 72.4872 133.902C73.5128 133.683 74.5901 134.011 75.5213 134.821C77.405 136.464 78.0927 139.623 77.055 141.866C76.5499 142.955 75.716 143.673 74.7087 143.886C74.587 143.914 74.4653 143.929 74.3436 143.941C73.4276 144.02 72.4933 143.682 71.6747 142.967ZM75.3782 134.988C74.5018 134.224 73.4915 133.914 72.5359 134.118C71.5986 134.319 70.8196 134.991 70.3418 136.017C69.3406 138.174 70.004 141.221 71.8177 142.803C72.6942 143.567 73.7045 143.877 74.6601 143.673C75.5973 143.472 76.3764 142.8 76.8542 141.774C77.8554 139.614 77.195 136.571 75.3782 134.988Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 59,
    width: 83,
    height: 72
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5615 59.1179L104.976 66.9622L98.5045 130.004L22.0899 122.16L28.5615 59.1179Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 64,
    width: 75,
    height: 62
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4662 98.923C29.4603 127.569 58.6668 126.171 65.3217 125.474C66.2214 125.378 67.1136 125.281 68.0126 125.193C74.6674 124.496 103.523 119.826 100.529 91.1799C97.4944 62.1975 67.6382 63.974 61.4522 64.6586C60.7048 64.7402 59.9507 64.8137 59.204 64.8878C53.01 65.5038 23.4312 69.9405 26.4662 98.923Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2005_12792)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5376 55.9227L19.0142 142.205L115.424 133.845L107.947 47.5703L11.5376 55.9227Z",
    fill: "url(#paint1_linear_2005_12792)"
  })))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 63,
    width: 75,
    height: 59
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9901 63.3308L100.763 70.3906L95.4684 121.97L26.6952 114.911L31.9901 63.3308Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 67,
    width: 69,
    height: 48
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3455 93.5453C97.9317 99.1481 97.3798 104.084 95.6921 108.329C92.9813 104.25 89.1675 101.22 84.2708 99.2615C76.4839 96.147 68.2421 96.5829 65.0629 96.9202L64.8494 96.9435C64.4678 96.9873 64.0945 97.0244 63.7055 97.0674C63.3247 97.1037 62.9432 97.1475 62.5624 97.1838L62.3496 97.1997C59.1712 97.5295 51.0167 98.8039 44.0455 103.465C39.6577 106.393 36.5501 110.146 34.7482 114.697C32.2203 110.893 30.6457 106.177 30.067 100.575C28.8525 88.9725 32.5345 80.2108 41.0185 74.5512C47.9964 69.8984 56.1434 68.6232 59.3293 68.2942L59.5354 68.2701C59.917 68.2263 60.2977 68.19 60.6785 68.1537C61.0601 68.1099 61.4416 68.0661 61.8224 68.0298L62.0359 68.0064C65.2151 67.6692 73.457 67.2333 81.2438 70.3477C90.7114 74.1324 96.1309 81.9432 97.3455 93.5453Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.962 63.757L27.428 126.871L105.257 120.125L99.7913 57.0114L21.962 63.757Z",
    fill: "url(#paint2_linear_2005_12792)"
  }))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 71,
    width: 71,
    height: 49
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1159 71.1685L98.0683 77.8361L93.754 119.864L28.8016 113.196L33.1159 71.1685Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0556 111.042L49.7952 114.303C40.6324 115.263 32.4352 108.653 31.4791 99.528C30.5222 90.4108 37.175 82.2406 46.3445 81.2891L77.5982 78.0197C86.761 77.06 94.9649 83.6785 95.9143 92.795C96.8712 101.912 90.2184 110.082 81.0556 111.042Z",
    fill: "#CCCCCC"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 101,
    width: 11,
    height: 9
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9363 101.051L70.4881 102.032L69.7037 109.673L60.1519 108.693L60.9363 101.051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.9421 103.447C61.9421 103.447 65.444 104.447 68.9316 102.649C68.9234 102.655 69.1032 103.843 69.1097 103.926C69.1574 104.783 69.1043 105.668 68.8611 106.495C68.4289 107.914 67.0203 109.368 65.3833 109.079C64.7909 108.973 64.2388 108.622 63.8136 108.209C62.5516 106.986 62.1266 105.102 61.9421 103.447Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 92,
    width: 11,
    height: 6
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3789 92.676L82.9308 93.6566L82.5385 97.4773L72.9867 96.4968L73.3789 92.676Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 47.9205L106.454 39.71L113.539 121.503L18.8336 129.714L11.7483 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 47.9205L106.454 39.71L113.539 121.503L18.8336 129.714L11.7483 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 47.9205L106.454 39.71L113.539 121.503L18.8336 129.714L11.7483 47.9205Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.119 93.223C79.205 93.2213 80.2645 93.4055 81.269 93.7575C81.9529 94.0011 82.3055 94.7537 82.0626 95.4301C81.8189 96.1139 81.0589 96.4657 80.3825 96.2229C78.9417 95.713 77.2981 95.7102 75.8576 96.2259C75.1687 96.4719 74.421 96.1161 74.1742 95.4347C73.9274 94.7533 74.2832 94.0056 74.9721 93.7596C75.974 93.4024 77.0329 93.2246 78.119 93.223Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 93,
    width: 11,
    height: 10
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2418 93.7512L55.7936 94.7318L55.0092 102.373L45.4574 101.393L46.2418 93.7512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 47.9203L106.454 39.7097L113.539 121.503L18.8336 129.713L11.7483 47.9203Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 47.9203L106.454 39.7097L113.539 121.503L18.8336 129.713L11.7483 47.9203Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7483 47.9203L106.454 39.7097L113.539 121.503L18.8336 129.713L11.7483 47.9203Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4925 96.3443C51.5545 96.1366 52.6287 96.1036 53.6838 96.2571C54.4046 96.3613 54.9014 97.0307 54.798 97.744C54.6872 98.4565 54.0178 98.9534 53.3045 98.85C51.7891 98.6266 50.1796 98.9515 48.8623 99.7363C48.2441 100.103 47.4347 99.9065 47.0609 99.2874C46.6796 98.6676 46.8825 97.8665 47.509 97.4934C48.4248 96.9465 49.4298 96.5595 50.4925 96.3443Z",
    fill: "#666666"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 31,
    width: 106,
    height: 81
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9344 31L115.363 41.0014L108.107 111.685L10.6785 101.683L17.9344 31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2005_12792)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2005_12792",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 39,
    width: 103,
    height: 91
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7482 47.9205L106.454 39.71L113.539 121.503L18.8335 129.714L11.7482 47.9205Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.4644 71.2151L97.2268 49.8179C99.3848 48.9233 100.695 46.5165 99.9605 44.0506C99.4107 42.207 97.74 40.8515 95.8101 40.6987C92.7429 40.4592 90.3445 43.0333 90.643 45.9295C90.8688 48.0642 92.4931 49.7241 94.5127 50.1048L96.735 71.3573C92.885 67.0633 88.3603 64.4195 84.289 62.795C74.8148 59.0021 64.9739 59.5152 61.1854 59.9106L60.9189 59.936C60.5597 59.9821 60.1939 60.0199 59.8437 60.0518C59.4704 60.0889 59.112 60.1276 58.7312 60.1639L58.4796 60.1908C54.6911 60.5862 44.9565 62.1207 36.4644 67.787C32.8782 70.1788 29.0705 73.6263 26.2116 78.4834L24.0095 57.4743C26.1684 56.5723 27.4787 54.1655 26.7514 51.7004C26.2017 49.8567 24.5227 48.508 22.6003 48.3559C19.5256 48.1156 17.1281 50.6823 17.4332 53.5868C17.659 55.7214 19.2759 57.3805 21.2962 57.7538L23.5338 79.1511C18.4798 79.6805 14.8052 84.1823 15.3294 89.2132L15.9651 95.2886C16.1662 97.1492 17.1018 98.761 18.4522 99.8574C19.4347 100.644 20.6261 101.159 21.9073 101.313C22.4133 101.38 22.9328 101.388 23.4517 101.328L24.6411 101.202L24.6323 101.14C22.8404 83.9966 30.906 74.7725 37.9819 70.0467C45.9649 64.7127 55.1692 63.2746 58.7524 62.8959L58.9966 62.8682C59.735 62.8007 60.4898 62.7198 61.2066 62.6426L61.4657 62.6164C65.0488 62.2377 74.3589 61.753 83.2687 65.3146C91.1712 68.4786 100.973 75.8418 102.765 92.978L102.766 93.0459L104.123 92.8987C104.595 92.8566 105.043 92.7593 105.471 92.6223C106.773 92.213 107.886 91.4374 108.714 90.4214C109.81 89.071 110.398 87.3065 110.198 85.4383L109.562 79.3704C109.046 74.3328 104.518 70.6858 99.4644 71.2151ZM20.1472 53.2998C20.036 52.1798 20.8477 51.1773 21.9752 51.0668C23.0959 50.9481 24.0984 51.7598 24.2179 52.8731C24.3367 53.9938 23.5174 54.9956 22.3967 55.1143C21.2693 55.2248 20.2667 54.413 20.1472 53.2998ZM93.3563 45.65C93.245 44.5301 94.0642 43.5283 95.1842 43.417C96.3049 43.2983 97.3149 44.1108 97.4269 45.2233C97.5457 46.344 96.7264 47.3458 95.6057 47.4646C94.4858 47.5758 93.4757 46.7633 93.3563 45.65Z",
    fill: "#662D91"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.174 103.226C116.03 103.992 113.789 104.161 111.723 103.998C111.458 103.974 111.2 103.952 110.937 103.918C105.828 103.286 105.523 101.653 102.523 97.8828C102.06 100.852 101.088 103.881 99.7267 106.562C98.0565 109.86 95.8729 112.846 93.4229 115.5C92.1629 116.864 90.5834 118.188 90.4126 120.149C90.3449 120.93 90.6163 122.438 91.7352 122.775C92.2026 122.915 92.6785 122.942 93.1265 122.921C95.3792 122.808 97.0389 121.497 98.476 120.167C98.9782 119.7 99.5104 119.267 100.054 118.832C100.693 118.316 101.333 117.797 101.981 117.276C102.841 116.579 103.706 115.876 104.576 115.163C105.575 114.346 106.578 113.523 107.587 112.687C108.63 111.824 109.682 110.948 110.739 110.058C111.73 109.226 112.727 108.377 113.719 107.516C114.547 106.799 115.373 106.072 116.189 105.317C116.733 104.814 117.284 104.309 117.784 103.752C117.926 103.59 118.094 103.424 118.174 103.226Z",
    fill: "#FAFAFA"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.4315 116.396C92.562 116.514 92.7872 116.804 92.959 116.801C92.6238 116.462 92.8344 117.049 93.1329 116.338C94.2725 114.964 93.1373 116.366 94.1465 115.12C96.1138 112.691 98.0862 109.953 99.9488 106.921C101.236 104.827 102.494 102.494 103.602 100.16C103.617 99.7276 103.631 99.2567 103.638 98.7395C102.409 101.481 100.943 104.274 99.434 106.741C97.5791 109.777 95.6156 112.519 93.6547 114.951C92.6465 116.201 93.4052 115.36 92.4315 116.396C92.5723 116.248 92.1299 117.117 92.4315 116.396Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M103.782 92.1734L111.238 95.2865C111.804 95.5222 112.356 95.415 112.446 95.0573L114.072 88.6107C114.148 88.3116 113.78 87.9196 113.266 87.7392L108.343 86.027C107.927 85.8812 107.52 85.9161 107.357 86.1144L103.149 91.1234C102.893 91.4313 103.188 91.9295 103.782 92.1734Z",
    fill: "#FFBD39"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M113.166 96.2045L120.265 99.4183C120.987 99.7451 121.674 99.6034 121.728 99.1177L122.694 90.7093C122.736 90.3544 122.294 89.8924 121.704 89.6706L117.247 87.9834C116.708 87.7809 116.197 87.8342 116.046 88.1098L112.323 94.9361C112.11 95.3231 112.493 95.9006 113.166 96.2045Z",
    fill: "#FFBD39"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M103.994 91.4925L120.211 98.6745C121.112 99.0744 121.6 99.9816 121.16 100.459L115.599 106.519C115.291 106.854 114.703 106.919 114.112 106.683L102.522 102.041C101.827 101.762 101.363 101.157 101.418 100.603L102.244 91.9777C102.309 91.3648 103.17 91.1271 103.994 91.4925Z",
    fill: "#FFBD39"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M121.488 100.07L102.941 91.8626C102.618 91.7182 102.445 91.4521 102.552 91.2624C102.659 91.0762 103.009 91.0422 103.329 91.1825L121.711 99.3012C122.045 99.4474 122.264 99.7391 122.203 99.9511C122.142 100.163 121.822 100.216 121.488 100.07Z",
    fill: "#F4A525"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M108.544 98.4512L105.8 91.1353C105.694 90.852 105.353 90.6187 104.946 90.5461L100.635 89.7763C99.9527 89.6536 99.3625 90.0054 99.4769 90.4729L101.783 100.013C101.916 100.562 102.703 100.911 103.368 100.711L108.021 99.3162C108.466 99.1838 108.682 98.8223 108.544 98.4512Z",
    fill: "#E6B64D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M109.012 99.0935L102.372 101.106C102.097 101.188 101.767 101.082 101.638 100.87C101.509 100.658 101.624 100.42 101.9 100.337L108.522 98.3687C108.771 98.2962 109.084 98.3958 109.219 98.5943C109.353 98.7928 109.262 99.0175 109.012 99.0935Z",
    fill: "#F4A525"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.1644 115.031L100.142 115.004C101.107 115 101.889 115.778 101.893 116.741L101.9 118.486L91.4333 118.526L91.4266 116.782C91.4229 115.819 92.1995 115.034 93.1644 115.031Z",
    fill: "#737576"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5438 118.661L105.388 118.473C107.314 118.465 108.883 120.022 108.89 121.948L108.998 149.859C109.005 151.785 107.448 153.354 105.522 153.362L56.6782 153.55C54.7523 153.557 53.1832 152 53.1758 150.074L53.0683 122.163C53.0609 120.237 54.6179 118.668 56.5438 118.661Z",
    fill: "#365673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4669 115.756C88.6601 115.713 97.7702 124.753 97.8133 135.947C97.8563 147.14 88.8161 156.25 77.623 156.293C66.4298 156.336 57.3198 147.296 57.2765 136.103C57.2334 124.909 66.2735 115.799 77.4669 115.756Z",
    fill: "#E4E5E6",
    stroke: "#2B414D",
    strokeWidth: 1.3291
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4835 120.325C86.155 120.291 93.2105 127.292 93.2439 135.964C93.2773 144.634 86.2761 151.691 77.6044 151.724C68.9328 151.758 61.8774 144.757 61.844 136.085C61.8106 127.415 68.8118 120.358 77.4835 120.325Z",
    fill: "#5B717C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5046 125.558C83.2856 125.536 87.9892 130.205 88.0115 135.984C88.0337 141.764 83.3662 146.469 77.5852 146.491C71.8058 146.513 67.1006 141.843 67.0783 136.065C67.0561 130.287 71.7252 125.58 77.5046 125.558Z",
    fill: "#2B414D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8784 129.031C83.3228 129.025 84.4995 130.193 84.505 131.637C84.5106 133.083 83.3428 134.258 81.8985 134.264C80.4543 134.269 79.2774 133.103 79.2719 131.657C79.2663 130.211 80.4339 129.036 81.8784 129.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.784 121.972C104.229 121.966 105.405 123.132 105.411 124.578C105.417 126.024 104.249 127.199 102.804 127.205C101.36 127.21 100.183 126.044 100.178 124.598C100.172 123.152 101.34 121.977 102.784 121.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9086 115.024L93.1641 115.031L93.1775 118.52L94.922 118.513L94.9086 115.024Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3973 115.011L96.6528 115.018L96.6663 118.507L98.4107 118.5L98.3973 115.011Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.142 115.004L100.155 118.493L101.899 118.487L101.893 116.742C101.889 115.779 101.106 115.001 100.142 115.004Z",
    fill: "#919191"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1221 128.421L55.1375 138.786C54.9217 139.159 54.9527 139.798 55.1988 140.06L59.0958 144.219C59.3654 144.506 59.711 144.567 59.9767 144.362L67.6595 138.399C68.3512 137.863 68.5643 136.968 68.1503 136.315L62.7145 127.755C62.3876 127.241 61.5964 127.601 61.1221 128.421Z",
    fill: "#FFBD39"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5885 137.782C55.5885 137.782 56.1716 139.346 54.2416 136.022C53.0857 134.031 54.254 134.17 53.7796 134.666C53.7796 134.666 55.757 137.543 51.9593 131.409C54.3192 127.318 52.2296 130.8 51.9593 131.409C49.8991 133.383 37.9332 132.634 36.5039 138.816C35.7091 142.254 37.9711 144.754 39.4925 145.487C40.1303 145.796 40.8011 145.924 41.4507 145.968C44.7232 146.189 47.3995 144.349 49.7647 142.428C50.5966 141.752 51.4608 141.137 52.3501 140.514C53.3957 139.78 54.4465 139.04 55.506 138.29C56.9224 137.289 54.1451 138.812 55.5885 137.782Z",
    fill: "#FAFAFA"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_2005_12792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9873 138.925L55.0629 149.949C54.4903 150.347 53.4559 150.381 53.0002 150.019L45.7765 144.284C45.2781 143.887 45.134 143.338 45.4296 142.882L54.0302 129.702C54.8029 128.516 56.2178 128.054 57.3268 128.635L71.8505 136.269C72.7233 136.728 72.248 138.052 70.9873 138.925Z",
    fill: "#FFBD39"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3063 136.936C60.0798 137.34 60.828 137.779 61.5478 138.256C61.9144 138.486 62.2638 138.738 62.6231 138.978L63.6724 139.735C65.0507 140.773 66.1228 141.7 65.9919 142.025C65.5222 142.441 64.6613 141.304 63.2657 140.289L62.233 139.509C61.8979 139.236 61.5541 138.976 61.2264 138.694C60.5604 138.143 59.9204 137.558 59.3063 136.936Z",
    fill: "#E28E07"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3063 136.936C60.0798 137.34 60.828 137.779 61.5478 138.256C61.9144 138.486 62.2638 138.738 62.6231 138.978L63.6724 139.735C65.0507 140.773 66.1228 141.7 65.9919 142.025C65.5222 142.441 64.6613 141.304 63.2657 140.289L62.233 139.509C61.8979 139.236 61.5541 138.976 61.2264 138.694C60.5604 138.143 59.9204 137.558 59.3063 136.936Z",
    fill: "#E28E07"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M53.633 141.538C54.4065 141.942 55.1547 142.381 55.8744 142.858C56.2411 143.088 56.5904 143.34 56.9497 143.58L57.999 144.337C59.3773 145.375 60.4494 146.302 60.3185 146.627C59.8488 147.043 58.9879 145.906 57.5923 144.891L56.5597 144.111C56.2245 143.838 55.8807 143.578 55.553 143.295C54.887 142.745 54.247 142.159 53.633 141.538Z",
    fill: "#E28E07"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M53.633 141.538C54.4065 141.942 55.1547 142.381 55.8744 142.858C56.2411 143.088 56.5904 143.34 56.9497 143.58L57.999 144.337C59.3773 145.375 60.4494 146.302 60.3185 146.627C59.8488 147.043 58.9879 145.906 57.5923 144.891L56.5597 144.111C56.2245 143.838 55.8807 143.578 55.553 143.295C54.887 142.745 54.247 142.159 53.633 141.538Z",
    fill: "#E28E07"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.041 66.2164C128.298 65.4842 127.929 64.9957 127.466 64.0479C126.999 64.2672 126.638 64.5366 126.404 64.9575C126.653 65.6235 127.135 66.3614 127.874 67.2871C128.181 66.5931 128.45 66.2888 129.041 66.2164Z",
    fill: "#61BA47"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.198 94.2953C146.058 93.7045 146.608 93.4358 147.626 93.1614C147.5 92.6609 147.304 92.2556 146.935 91.9461C146.234 92.0636 145.418 92.3967 144.369 92.9457C144.991 93.3795 145.239 93.7013 145.198 94.2953Z",
    fill: "#007AFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.168 91.3252C129.675 90.7657 129.712 90.2172 129.741 89.39C129.155 88.8432 128.771 88.3665 128.222 87.9851C127.502 88.4547 126.918 88.6076 125.847 88.4519C126.939 89.8364 127.742 90.4494 129.168 91.3252Z",
    fill: "#61BA47"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.512 53.4278C103.576 52.9664 103.073 52.6185 102.335 51.8643C101.96 52.2194 101.703 52.5886 101.613 53.0616C102.059 53.6157 102.748 54.1646 103.74 54.8112C103.814 54.0557 103.973 53.6824 104.512 53.4278Z",
    fill: "#A550A7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.945 69.4797C111.032 69.9837 110.458 70.1976 109.418 70.3713C109.495 70.8818 109.65 71.3043 109.987 71.6482C110.697 71.5997 111.541 71.3478 112.639 70.9038C112.061 70.4113 111.846 70.0669 111.945 69.4797Z",
    fill: "#007AFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.284 88.099C117.312 87.3443 116.987 86.9008 116.476 86.2493C115.676 86.208 115.075 86.0906 114.41 86.1518C114.161 86.9748 113.813 87.4679 112.893 88.0381C114.619 88.3949 115.629 88.3467 117.284 88.099Z",
    fill: "#FFC700"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.159 74.5965C123.599 73.7161 123.349 73.1574 123.111 72.1299C122.606 72.2387 122.194 72.4203 121.872 72.778C121.965 73.4829 122.269 74.3102 122.781 75.3779C123.237 74.7706 123.567 74.5345 124.159 74.5965Z",
    fill: "#FFC700"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.725 67.336C113.513 66.6522 114.029 66.3233 115.01 65.9361C114.828 65.453 114.588 65.0723 114.187 64.8063C113.503 65.002 112.73 65.4247 111.749 66.0883C112.417 66.4492 112.699 66.7411 112.725 67.336Z",
    fill: "#F74F9E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.881 53.4025C134.242 52.9986 133.696 53.0561 132.876 53.1696C132.438 53.8406 132.034 54.3008 131.752 54.9065C132.338 55.5356 132.589 56.0848 132.619 57.1665C133.796 55.8539 134.262 54.9572 134.881 53.4025Z",
    fill: "#61BA47"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1721 77.7472C92.7749 78.2022 93.3245 78.1898 94.1509 78.1441C94.6429 77.5115 95.0832 77.086 95.4138 76.5056C94.8814 75.8304 94.6766 75.2624 94.7355 74.1819C93.4546 75.3933 92.9163 76.2485 92.1721 77.7472Z",
    fill: "#F74F9E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.986 70.8961C132.944 70.8547 132.343 70.7411 131.362 70.3514C131.164 70.828 131.079 71.2701 131.189 71.7387C131.821 72.0641 132.674 72.2857 133.843 72.4737C133.604 71.7534 133.598 71.3474 133.986 70.8961Z",
    fill: "#F74F9E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.456 87.6796C154.65 88.705 154.675 89.3163 154.515 90.359C155.024 90.445 155.474 90.429 155.906 90.2162C156.081 89.5272 156.105 88.6461 156.026 87.4647C155.378 87.8599 154.983 87.9567 154.456 87.6796Z",
    fill: "#F74F9E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.645 82.916C132.655 83.6712 133.002 84.0977 133.545 84.7224C134.346 84.7229 134.953 84.8097 135.614 84.7148C135.82 83.8802 136.144 83.3701 137.033 82.7539C135.291 82.4852 134.285 82.5846 132.645 82.916Z",
    fill: "#FF5257"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2005_12792",
    x: 41.6082,
    y: 122.7,
    width: 50.1745,
    height: 48.1743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_12792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_12792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2005_12792",
    x: 7.53763,
    y: 1.57031,
    width: 111.887,
    height: 140.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_12792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_12792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2005_12792",
    x: 90.4029,
    y: 96.8828,
    width: 29.7712,
    height: 26.0444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_12792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_12792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2005_12792",
    x: 36.3394,
    y: 129.448,
    width: 19.5822,
    height: 17.5386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_12792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_12792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2005_12792",
    x: 44.2771,
    y: 128.385,
    width: 28.0185,
    height: 22.8855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2005_12792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2005_12792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2005_12792",
    x1: 90.8636,
    y1: 145.726,
    x2: 41.6671,
    y2: 146.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2005_12792",
    x1: 58.8733,
    y1: 50.9798,
    x2: 68.0458,
    y2: 138.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0193044,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980696,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2005_12792",
    x1: 59.7951,
    y1: 59.8063,
    x2: 66.5185,
    y2: 124.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0212642,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#EDEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.978736,
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2005_12792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 113,
    fill: "white",
    transform: "translate(0 31)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2005_12792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.8224,
    height: 55.8224,
    fill: "white",
    transform: "translate(53.0153 108.208) rotate(-0.220698)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAfinandinhoSucesso);
export default __webpack_public_path__ + "static/media/avatar_afinandinho_sucesso.a343be2d37bb276aacc17d6ac63ced56.svg";
export { ForwardRef as ReactComponent };